// extracted by mini-css-extract-plugin
module.exports = {"content":"verify_lawyer_modal_components-module__content--2s085"};